'use client';

import { Input } from '@/components/ui/input';

export default function SearchForm({ placeholder }) {
  return (
    <section className='bg-primary pb-6'>
      <div className='container'>
        <Input className='border-0 rounded-none pl-0 pb-4 focus-visible:ring-0 placeholder:italic placeholder:text-background text-xl md:text-3xl border-b border-background' placeholder={placeholder} />
      </div>
    </section>
  );
}
